module.exports = __webpack_public_path__ + "static/canvas-866d3e97423b547bb068c21c4aed25d2.png";